import { JOB_CANCELED } from 'constants/JobStatus';
function isShipmentCanceled(item) {
    var _a;
    const shipment = item.shipment;
    if (!shipment)
        return false;
    if (shipment.canceled === true)
        return true;
    const status = ((_a = shipment.status) !== null && _a !== void 0 ? _a : '').toLowerCase();
    return status === JOB_CANCELED || status === 'job canceled';
}
export function filterCanceledShipmentLineItems(items) {
    return items.filter((item) => !isShipmentCanceled(item));
}
